import { GoogleGenerativeAI } from "@google/generative-ai";

const ALLOWED_ICONS = [
  "IoSparkles",
  "IoRestaurant",
  "IoSunny",
  "IoMoon",
  "IoLocationSharp",
  "IoPerson",
  "IoPeople",
  "IoHome",
  "IoBed",
  "IoPaw",
  "IoThermometer",
  "IoCheckmarkCircle",
  "IoStatsChart",
];

export const generatePreferenceInsights = async (rawData) => {
  const model = genAI.getGenerativeModel({
    model: geminiModel,
    generationConfig: {
      temperature: 0.2,
      responseMimeType: "application/json",
    },
  });

  const prompt = `
You are generating dashboard cards for hotel preference analytics.

DATA:
${JSON.stringify(rawData)}

STRICT RULES:
- Return ONLY JSON
- Do NOT invent values
- Use only given data
- Must have exactly 3 summaryCards
- You MUST return exactly 6 insightCards.
- If fewer insights are available, still return 6 by selecting the most relevant ones.
- Do NOT return less or more than 6.
- Must have operationalNotes if any operational insights can be derived from the data.
- Use only these icons: ${ALLOWED_ICONS.join(", ")}

FORMAT:
{
  "title": "Guest Preference Insights",
  "subtitle": "string",
  "summaryCards": [
    {
      "title": "string",
      "value": "string",
      "sub": "string",
      "icon": "IoStatsChart",
      "color": "success"
    }
  ],
  "insightCards": [
    {
      "title": "string",
      "icon": "IoSparkles",
      "description": "string",
      "items": [
        {
          "label": "string",
          "value": "string",
          "sub": "string"
        }
      ]
    }
  ],
  "operationalNotes": []
}
`;

  const result = await model.generateContent(prompt);
  const text = result.response.text();

  return JSON.parse(text);
};
